import { useContext } from 'react';
import RadioButton from '../../generics/RadioButton';
import './PageRadioButton.css';
import Instruction from '../../generics/Instruction';
import { SlidesContext } from '../../contexts/SlidesContext';
import ReviewFormattedMessage from '../../generics/ReviewFormattedMessage';

export default function PageRadioButton ({ slide }) {
  const { slidesAnswers, updateValues } = useContext(SlidesContext);

  const handleChange = (event) => {
    const target = event.target;
    const value= target.value;
    updateValues(slide.inputNumber, slide.key, value);
  }

  return (
    <div className="PageRadioButton animate__animated animate__fadeInRight">
      { slide.information ? <div className="PageRadioButton-information"><ReviewFormattedMessage descriptor={slide.information} /></div> : null }
      <Instruction instructions={slide.instructions} /> 
      <div className="PageRadioButton-radioButtonList">
        {
          slide.inputs.map((input, index) => {
            return <RadioButton key={index} label={input.label} value={slidesAnswers[slide.inputNumber][slide.key]} valueKey={input.valueKey} handleChange={handleChange} />
          })
        }
      </div>
    </div>
  );
}
